(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-directional-fill"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__smFillInit) return;
    window.__smFillInit = true;

    function getDirection(e, el) {
      const rect = el.getBoundingClientRect();
      const w = rect.width;
      const h = rect.height;
      const x = ((e.clientX - rect.left) / w) - 0.5;
      const y = ((e.clientY - rect.top) / h) - 0.5;
      const ax = Math.abs(x);
      const ay = Math.abs(y);
      if (ax > ay) {
        return x < 0 ? 'left' : 'right';
      }
      return y < 0 ? 'top' : 'bottom';
    }

    function dirToTransform(dir) {
      switch (dir) {
        case 'right':  return 'translateX(101%)';
        case 'top':    return 'translateY(-101%)';
        case 'bottom': return 'translateY(101%)';
        default:       return 'translateX(-101%)';
      }
    }

    function bind(el) {
      if (el.__smFillBound) return;
      el.__smFillBound = true;
      el.addEventListener('mouseenter', function (e) {
        const dir = getDirection(e, el);
        el.style.setProperty('--sm-fill-pos', dirToTransform(dir));
      });
      el.addEventListener('mouseleave', function (e) {
        const dir = getDirection(e, el);
        el.style.setProperty('--sm-fill-pos', dirToTransform(dir));
      });
    }

    function bindAll(root) {
      (root || document).querySelectorAll('[data-sm-fill]').forEach(bind);
    }

    bindAll(document);

    // re-bind po zmianach DOM (np. cart drawer refresh)
    const mo = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-sm-fill]')) bind(node);
          if (node.querySelectorAll) bindAll(node);
        });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-fly-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__smFlyInit) return;
    window.__smFlyInit = true;

    var CHIP_SIZE = 70;

    function getCartTarget() {
      var triggers = document.querySelectorAll('[data-sm-cart-trigger]');
      for (var i = 0; i < triggers.length; i++) {
        var t = triggers[i];
        var r = t.getBoundingClientRect();
        var visible = r.width > 0 && r.height > 0 &&
                      r.top < window.innerHeight && r.bottom > 0 &&
                      window.getComputedStyle(t).visibility !== 'hidden' &&
                      window.getComputedStyle(t).display !== 'none';
        if (visible) return t;
      }
      return null;
    }

    function fly(button) {
      var target = getCartTarget();
      if (!target) return;

      var btnRect = button.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();

      var startX = btnRect.left + btnRect.width / 2 - CHIP_SIZE / 2;
      var startY = btnRect.top + btnRect.height / 2 - CHIP_SIZE / 2;
      var endX = targetRect.left + targetRect.width / 2 - CHIP_SIZE / 2;
      var endY = targetRect.top + targetRect.height / 2 - CHIP_SIZE / 2;

      var chip = document.createElement('div');
      chip.className = 'sm-fly-chip';
      chip.textContent = 'GLOW';
      chip.style.transform = 'translate(' + startX + 'px, ' + startY + 'px) scale(1)';
      chip.style.opacity = '1';
      document.body.appendChild(chip);

      // force reflow zeby pierwsza klatka byla zarejestrowana
      void chip.offsetHeight;

      requestAnimationFrame(function () {
        chip.style.transform = 'translate(' + endX + 'px, ' + endY + 'px) scale(0.25)';
        chip.style.opacity = '0';
      });

      setTimeout(function () {
        target.classList.add('sm-fly-bump');
        setTimeout(function () { target.classList.remove('sm-fly-bump'); }, 400);
        if (chip.parentNode) chip.parentNode.removeChild(chip);
      }, 750);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sm-fly]');
      if (!btn) return;
      if (btn.disabled) return;
      fly(btn);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
